import React from 'react'
import {Form, Select} from "antd";
import {dispute_types} from "../../requist";

const { Option } = Select;

class DropDownBox extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        return <Form.Item
            label="Select Type Of Claim / Dispute"
            name="claimDispute"
            rules={[{ required: false }]}
            labelCol={{ span: 10 }}
            wrapperCol={{ span: 10}}
            style={{marginBottom:'20px'}}
        >
            <Select listItemHeight={10} listHeight={450} defaultValue="Please Select" onChange={this.props.callback}>
                {
                    this.props.optionList?this.props.optionList.map((item)=>{
                        return <Option value={item.disputeType} >{item.disputeTypeText}</Option>
                    }):''
                }
            </Select>
        </Form.Item>
    }
}

export default DropDownBox;